import { useApiPost } from '@/api/main/query'
import { disputsAPI } from '../api/endpoints'
import { useQueryClient } from '@tanstack/react-query'
import { useToast } from '@/shared/hooks'
import { DisputListModel, NewDisputModel } from '../model'

export const useCreateDisput = (onSuccessCallback?: () => void) => {
  const { addToast } = useToast()
  const queryClient = useQueryClient()

  const { mutate: createDisput, isPending: isPendingCreate } = useApiPost<
    DisputListModel,
    NewDisputModel
  >(disputsAPI.create, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['disputs'] })
      addToast('Успешно!', 'Диспут создан', 'success')
      if (onSuccessCallback) onSuccessCallback()
    },
    onError: (error) => {
      addToast('Ошибка!', error.message, 'error')
    },
  })

  const handleCreateDisput = (data: NewDisputModel) => {
    createDisput(data)
  }

  return { handleCreateDisput, isPendingCreate }
}
